import * as React from 'react';
import { Modal } from '@cian/ui-kit';
import { TRoundButtonTheme } from '@cian/ui-kit/button/types';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';

export interface IRequestFormModalWindowProps {
  content: React.ReactElement;
  footer?: React.ReactElement;
  onClose: () => void;
  open: boolean;
  header?: React.ReactElement;
}

export const RequestFormModalWindow: React.FC<IRequestFormModalWindowProps> = ({
  content,
  footer,
  onClose,
  open,
  header,
}) => {
  return (
    <Modal
      closeButtonProps={{ theme: 'fill_light' as TRoundButtonTheme, title: 'Закрыть', icon: <IconActionClose12 /> }}
      footer={footer || undefined}
      header={header}
      onOpenChange={onClose}
      open={open}
      size="S"
      body={content}
    />
  );
};
